export default "__VITE_ASSET__BKzjv0FJ__"